import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Modal from 'react-bootstrap/Modal';
import ModalHeader from '../../../components/ModalHeader';
import { Container, Row, Col } from 'react-bootstrap';
import Button from '../../../components/Button';

export type ClaimsReimbursementOtherFormsType = {
  title?: string;
  subTitles: { subTitle: string; link: string; target: string }[];
}[];

const ClaimsReimbursementOtherFormsOptions: ClaimsReimbursementOtherFormsType =
  [
    {
      subTitles: [
        {
          subTitle: 'Adoption Surrogacy Reimbursement Form',
          link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
          target: '_blank',
        },
        {
          subTitle: 'HealthEquity Reimbursement Form',
          link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
          target: '_blank',
        },
        {
          subTitle: 'Global Plan Claim Form',
          link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
          target: '_blank',
        },
        {
          subTitle: 'Evidence of Insurability (EOI) Form',
          link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
          target: '_blank',
        },
        {
          subTitle: 'HealthEquity Direct Deposit Authorization Form',
          link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
          target: '_blank',
        },
        {
          subTitle: 'Dental Claim Form',
          link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
          target: '_blank',
        },
        {
          subTitle: 'Domestic Partner Declaration Form',
          link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
          target: '_blank',
        },
        {
          subTitle: 'Family Member Certification Form',
          link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
          target: '_blank',
        },
      ],
    },
  ];

export type ClaimsReimbursementOtherFormsProps = {
  showClaimsReimbursementOtherFormsModal: boolean;
  handleCloseClaimsReimbursementOtherFormsModal: () => void;
};

function ClaimsReimbursementOtherFormsModal({
  showClaimsReimbursementOtherFormsModal,
  handleCloseClaimsReimbursementOtherFormsModal,
}: ClaimsReimbursementOtherFormsProps) {
  return (
    <>
      <Modal
        className={'p-0'}
        show={showClaimsReimbursementOtherFormsModal}
        onHide={handleCloseClaimsReimbursementOtherFormsModal}
        dialogClassName="modal-xl"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <ModalHeader closeButton={true} leftIcon={light('folder')}>
          <h4 className="text-sm-20-lg-24">
            Claim/Reimbursement & Other Forms
          </h4>
        </ModalHeader>
        <Modal.Body>
          <Container className={'p-0'}>
            {ClaimsReimbursementOtherFormsOptions.map(
              ({ title, subTitles }, index) => {
                return (
                  <Row key={index}>
                    <Col>
                      <h6
                        className={
                          'mb-0 pb-4 border-bottom border-info text-primary text-fs-base fw-normal'
                        }
                      >
                        {title}
                      </h6>
                    </Col>
                    <Col className={'col-12 mc-layout-2-col mb-12'}>
                      {subTitles.map(({ subTitle, link, target }, index) => {
                        return (
                          <Row key={index}>
                            <Col>
                              <div
                                className={
                                  'd-flex mb-0 py-6 text-fs-6 border-bottom border-info fw-light'
                                }
                                key={index}
                              >
                                {subTitle}
                                <a
                                  className={'text-decoration-none ms-auto'}
                                  href={link}
                                  target={target}
                                >
                                  <FontAwesomeIcon icon={light('file-pdf')} />
                                  <span className={'ms-5'}>PDF</span>
                                </a>
                              </div>
                            </Col>
                          </Row>
                        );
                      })}
                    </Col>
                  </Row>
                );
              }
            )}
          </Container>
        </Modal.Body>
        <Modal.Footer className={'pt-0'}>
          <Button
            variant="primary-outline"
            onMouseDown={handleCloseClaimsReimbursementOtherFormsModal}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ClaimsReimbursementOtherFormsModal;
